import { render, staticRenderFns } from "./link-collection.vue?vue&type=template&id=ede5f308&"
import script from "./link-collection.vue?vue&type=script&lang=js&"
export * from "./link-collection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports